var _path, _path2, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAdviseLocation = function SvgAdviseLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81,
    height: 66,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4EADF1",
    d: "M64.667 24.459c0 12.952-14.79 31.759-21.149 39.247a3.713 3.713 0 0 1-5.703 0c-6.36-7.489-21.148-26.295-21.148-39.247 0-13.5 11.297-23.5 24-23.5s24 10 24 23.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2399EE",
    d: "M40.667 65.04a3.73 3.73 0 0 0 2.85-1.334c6.36-7.489 21.15-26.295 21.15-39.247 0-13.5-11.298-23.5-24-23.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1081D3",
    d: "M56.236 46.515c4.6-7.361 8.43-15.47 8.43-22.061 0-13.324-11.003-23.238-23.501-23.495z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.666,
    cy: 24.959,
    r: 10,
    fill: "#103C68"
  })));
};
export { SvgAdviseLocation as ReactComponent };
export default "/images/advise_location.svg";